import { hDtEnum } from "./types/enum";
import { isHigoOrChat, compareVersion } from "./utils";
import { getDeviceInfo } from "./getDeviceInfo";
const closeWindow = (status = "all") => {
  window.HiyaJSBridge.callHandler("closeWindow", {
    status: status === "all" ? 0 : 1
  });
};
const closeAllWindow = () => {
  closeWindow("all");
};
const closeCurWindow = (openSchemeCallBack) => {
  getDeviceInfo().then((res) => {
    if (res.h_dt === hDtEnum.ios) {
      closeWindow("cur");
    } else {
      const isSuper = isHigoOrChat(res.h_app) && compareVersion(res.h_av, "4.24.0");
      if (isSuper) {
        closeWindow("cur");
      } else {
        closeWindow("all");
        openSchemeCallBack && openSchemeCallBack();
      }
    }
  });
};
export {
  closeAllWindow,
  closeCurWindow
};
